// The six tones of status.ts, as classes. One map per use, so a page that
// colours something by state never picks a colour itself.

import type { Tone } from "@/components/emc/status";

/** A pill, a tinted callout, an icon tile: the soft fill and its ink. */
export const TONE_SOFT: Record<Tone, string> = {
  running: "bg-blue-soft text-blue-ink",
  scheduled: "bg-indigo-soft text-indigo-ink",
  good: "bg-green-soft text-green-ink",
  warn: "bg-orange-soft text-orange-ink",
  danger: "bg-red-soft text-red-ink",
  muted: "bg-gray-soft text-gray-ink",
};

/** Text that carries a state: the ink step, legible on a card. */
export const TONE_TEXT: Record<Tone, string> = {
  running: "text-blue-ink",
  scheduled: "text-indigo-ink",
  good: "text-green-ink",
  warn: "text-orange-ink",
  danger: "text-red-ink",
  muted: "text-muted-foreground",
};

/** A bar's fill, a dot, an icon: the bright system colour. */
export const TONE_FILL: Record<Tone, string> = {
  running: "bg-primary",
  scheduled: "bg-indigo",
  good: "bg-success",
  warn: "bg-warning",
  danger: "bg-destructive",
  muted: "bg-tertiary",
};

/** An icon drawn in the state's colour. */
export const TONE_ICON: Record<Tone, string> = {
  running: "text-primary",
  scheduled: "text-indigo",
  good: "text-success",
  warn: "text-warning",
  danger: "text-destructive",
  muted: "text-muted-foreground",
};
